import { UploadOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import React from "react";

interface BulkUploadsFilterMenuProps {
  count: number;
  handleOpenBulkUploadModal: () => void;
}

const BulkUploadsFilterMenu: React.FC<BulkUploadsFilterMenuProps> = ({
  count,
  handleOpenBulkUploadModal,
}) => {
  return (
    <div className="bulk-uploads-filter-menu">
      <div>
        <Typography.Title level={5} style={{ margin: 0 }}>
          Bulk Uploads {count > 0 ? `(${count})` : ""}
        </Typography.Title>
      </div>
      <Button
        type="primary"
        icon={<UploadOutlined />}
        onClick={handleOpenBulkUploadModal}
      >
        Upload Zip File
      </Button>
    </div>
  );
};

export default BulkUploadsFilterMenu;
